import React from 'react';
import { Check, X } from 'lucide-react';
import { Section } from './Shared';
export const Bitacora = () => {
  const comparison = [{
    situation: 'Querés empezar pero no sabés por dónde',
    without: 'Abrís el Tomo 1 y te perdés en la teoría',
    with: 'Abrís el Día 1 y hacés exactamente esto'
  }, {
    situation: 'Tenés poco tiempo por día',
    without: 'Buscás qué práctica hacer cada mañana',
    with: 'La página del día te dice exactamente qué hacer en 5 min'
  }, {
    situation: 'Sentís que no avanzás',
    without: 'No tenés forma de medir el progreso',
    with: 'El Tracker semanal te muestra el avance real'
  }, {
    situation: 'Terminaste los 6 Tomos y querés reforzar',
    without: 'Releés todo de nuevo',
    with: 'La Agenda consolida todo en 90 días de acción pura'
  }, {
    situation: 'Días de baja energía',
    without: 'Saltás la práctica',
    with: 'La acción mínima del día ya está pre-diseñada'
  }];
  const checklist = ['90 páginas diarias — Una por día, lista para completar', '90 Decretos únicos — Uno específico para cada día del proceso', '90 Acciones Inspiradas — Una acción concreta de menos de 5 minutos', '13 Revisiones Semanales — Tracker de frecuencia, ingresos y victorias', '3 Ciclos de Transformación — Despertar, Construcción y Multiplicación', 'Gran Cierre del Día 90 — Ritual de sello con comparativa de inicio vs. fin'];
  return <Section data-id="element-15">
      <div className="text-center mb-12" data-id="element-16">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[22px]" data-id="element-17">
          <span className="mr-3" data-id="element-18">🕊️</span> ¿QUÉ AGREGA EL UPSELL "INSTANTE
          ABUNDANTE"?
        </h2>
        <p className="text-brand-gold text-lg" data-id="element-19">
          La Agenda de Manifestación de 90 días — La vía rápida al resultado.
        </p>
      </div>

      {/* Desktop: 3-column grid */}
      <div className="hidden md:block" data-id="element-20">
        <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-21">
          <div className="font-serif font-bold text-lg text-brand-text/80" data-id="element-22">
            Situación real
          </div>
          <div className="font-serif font-bold text-lg text-red-400 flex items-center" data-id="element-23">
            <X className="w-5 h-5 mr-2" data-id="element-24" /> Sin Agenda
          </div>
          <div className="font-serif font-bold text-lg text-brand-gold flex items-center" data-id="element-25">
            <Check className="w-5 h-5 mr-2" data-id="element-26" /> Con Instante Abundante
          </div>
        </div>
        <div className="space-y-3" data-id="element-27">
          {comparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 glass-panel p-4 rounded-xl items-center" data-id="element-28">
              <div className="text-sm font-medium text-brand-text/90 pr-4" data-id="element-29">
                {row.situation}
              </div>
              <div className="text-sm text-brand-text/60 pr-4" data-id="element-30">
                {row.without}
              </div>
              <div className="text-sm text-brand-gold/90 font-medium bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20" data-id="element-31">
                {row.with}
              </div>
            </div>)}
        </div>
      </div>

      {/* Mobile: stacked cards */}
      <div className="md:hidden space-y-4" data-id="element-32">
        {comparison.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl space-y-3" data-id="element-33">
            <p className="text-sm font-medium text-brand-text/90" data-id="element-34">
              {row.situation}
            </p>
            <div className="flex items-start space-x-2" data-id="element-35">
              <X className="w-4 h-4 text-red-400 mt-0.5 shrink-0" data-id="element-36" />
              <span className="text-sm text-brand-text/60" data-id="element-37">{row.without}</span>
            </div>
            <div className="flex items-start space-x-2 bg-brand-gold/10 p-3 rounded-lg border border-brand-gold/20" data-id="element-38">
              <Check className="w-4 h-4 text-brand-gold mt-0.5 shrink-0" data-id="element-39" />
              <span className="text-sm text-brand-gold/90 font-medium" data-id="element-40">
                {row.with}
              </span>
            </div>
          </div>)}
      </div>

      <div className="mt-16 max-w-3xl mx-auto glass-panel p-8 md:p-10 rounded-3xl border-brand-gold/30 relative overflow-hidden" data-id="element-41">
        <div className="absolute top-0 left-0 w-full h-1 gold-gradient-bg" data-id="element-42"></div>
        <h3 className="text-2xl font-serif font-bold mb-8 flex items-center" data-id="element-43">
          <Check className="w-6 h-6 text-brand-gold mr-3" data-id="element-44" /> La Agenda Instante
          Abundante incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-45">
          {checklist.map((item, i) => <div key={i} className="flex items-start" data-id="element-46">
              <div className="w-1.5 h-1.5 rounded-full bg-brand-gold mt-2 mr-3 shrink-0" data-id="element-47"></div>
              <span className="text-brand-text/80 text-sm leading-relaxed" data-id="element-48">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </Section>;
};